import React from 'react';
import { connect } from 'react-redux'
import { DualTitleHeaderComponent } from "../../layout/HeaderComponent.js"
import IconButton from "@material-ui/core/IconButton";
import { MdArrowBack, MdWarning } from 'react-icons/md';

import { SecondaryButton } from "../../styled-components/Buttons/Buttons";

import {
    draftFinancialReimbursementApplication,
} from "../../../redux/actions/index";

const mapStateToProps = state => {
    return {
        lempgUserType: state.rootReducer.lempgUserType,
        currentQuarter: state.rootReducer.currentQuarter,
        grantApplication: state.rootReducer.grantApplication,
        selectedCounty: state.rootReducer.selectedCounty,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        draftFinancialReimbursementApplication: (payload) => dispatch(draftFinancialReimbursementApplication(payload)),        
    }
}

class FinancialReimbursementChangesRequested extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.changeFinancialReimStatusToDraft = this.changeFinancialReimStatusToDraft.bind(this);
    }

    changeFinancialReimStatusToDraft () {
        this.props.draftFinancialReimbursementApplication();
    }

    goBack = () => {
        this.props.history.goBack();
    }

    render() {
        const quarterSubheaderTitle = "Q" + parseInt(this.props.currentQuarter.quarter.split("").reverse())

        return (
            <div className="layout vertical full-height">

                <DualTitleHeaderComponent
                    icon={
                        <IconButton
                            aria-label="close"
                            onClick={this.goBack}
                        >
                            <MdArrowBack className="icon" />
                        </IconButton>

                    }
                    titleBig={<span>Financial Reimbursement</span>}
                    titleSmall={<span style={{ textTransform: "capitalize" }}>{quarterSubheaderTitle}  • {this.props.selectedCounty && this.props.selectedCounty.groupName}</span>}
                />

                <div className="flex layout vertical center vertical-center container-overflow-y">

                    <MdWarning className="icon-2 application-status-icon" />
                    <div className="height-20"></div>
                    <span className="layout horizontal center center-justified application-status-title-small">Changes Requested</span>
                    <div className="height-20"></div>

                    <div style={{ padding: "0 16px", maxWidth: "456px", lineHeight: "1.5" }} className="text-center title-big opacity-54">The state found errors within your Financial Reimbursement form. If you have any questions, reach out to your State contact.</div>

                    <div className="height-20"></div>

                    <div className="layout horizontal center-justified">
                        <SecondaryButton onClick={() => this.changeFinancialReimStatusToDraft()}>Edit Reimbursement Form</SecondaryButton>
                    </div>

                </div>

            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FinancialReimbursementChangesRequested);
